import moment from 'moment-timezone';
import { hasValue } from '@famly/stat_ts-utils_has-value';
const makeIsMinutesLaterThanNow = (minutesNow) => (minutes) => minutes > minutesNow;
export const timesLaterThanNow = (times, timezone) => {
    const now = moment.tz(timezone);
    const hoursNow = now.hours();
    const minutesNow = now.minutes();
    const isMinutesLaterThanNow = makeIsMinutesLaterThanNow(minutesNow);
    return times
        .map(time => 
    // Use only minutes within the current hour from now forward
    time.hour !== hoursNow ? time : { ...time, minutes: time.minutes.filter(isMinutesLaterThanNow) })
        .filter(time => time.hour >= hoursNow && time.minutes.length > 0);
};
export const isBeforeNow = (timezone, selectedHours, selectedMinutes) => {
    if (!hasValue(selectedHours) || !hasValue(selectedMinutes)) {
        return false;
    }
    const now = moment.tz(timezone);
    const hoursNow = now.hours();
    const minutesNow = now.minutes();
    if (hoursNow > selectedHours || (hoursNow === selectedHours && minutesNow > selectedMinutes)) {
        return true;
    }
    return false;
};
